<template>
  <!-- 小规模增值税及附加税费申报表-->
  <div>
    <div class="big_box4">
      <div>
        <el-radio-group v-model="expStatus">
          <el-radio :label="true">使用公式</el-radio>
          <el-radio :label="false">不使用公式</el-radio>
        </el-radio-group>
      </div>
      <div class="top_title3">
        <h4>{{title}}</h4>
        <h5>小规模纳税人适用</h5>
        <div class="bottom_font clearfix">
          <h6 class="left">纳税人名称：<span>{{$store.getters['user/comInfo'].comName}}</span></h6>
          <h6 class="center">税款所属期：<span>{{durationOfTaxTime}}</span></h6>
          <h6 class="right">
            <p>单位：元</p>
            <p>纳税人识别号：<span>{{$store.getters['user/comInfo'].taxNo}}</span></p>
          </h6>
        </div>
      </div>
      <table class="content" cellspacing="0">
         <tr>
          <td colspan="2" class="center weight" style="background:#eee">计税依据修改原因</td>
          <td colspan="3" class="center">
            <el-select @change="changeJsyj" v-model="infoFjs.jsyj" placeholder="请选择" size="mini" filterable style="width:100%" clearable>
                <el-option
                  v-for="item in jsyjOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
          </td>
          <td colspan="3" class="center weight" style="background:#eee">其他修改原因</td>
          <td colspan="2" class="center weight">
            <el-input size="mini" v-model="infoFjs.qtxgyy"></el-input>
          </td>
        </tr>
        <tr class="top_bg">
          <td rowspan="3" class="center weight" style="width:12%;">税（费）种</td>
          <td class="center weight" style="width:12%">计税（费）依据</td>
          <td rowspan="2" class="center weight" style="width:5%">税（费）率</td>
          <td rowspan="2" class="center weight" style="width:12%">本期应纳税（费）额</td>
          <td colspan="2" class="center weight" style="width:18%">本期减免税（费）额</td>
          <td colspan="2" class="center weight" style="width:18%">增值税小规模纳税人“六税两费”减征政策</td>
          <td rowspan="2" class="center weight" style="width:12%">本期已缴税（费）额</td>
          <td rowspan="2" class="center weight" style="width:12%">本期应补（退）税（费）额</td>
        </tr>

        <tr class="top_bg">
          <td class="center weight" style="width:12%">增值税税额</td>
          <td class="center weight" style="width:9%">减免性质代码</td>
          <td class="center weight" style="width:9%">减免税（费）额</td>
          <td class="center weight" style="width:9%">减征比例</td>
          <td class="center weight" style="width:9%">减征额</td>
        </tr>
        <tr class="top_bg">
          <td class="center">1</td>
          <td class="center">2</td>
          <td class="center">3=1×2</td>
          <td class="center">4</td>
          <td class="center">5</td>
          <td class="center">6</td>
          <td class="center">7=(3-5)×6</td>
          <td class="center">8</td>
          <td class="center">9=3-5-7-8</td>
        </tr>

        <tr>
          <td class="center">{{list[0].zsxm_dm}}</td>
          <qzf-str-td :disabled="false" v-model:amount="list[0].zzsse" @change="changeList()"></qzf-str-td>
          <qzf-str-td :disabled="false" v-model:amount="list[0].sl" @change="changeList()"></qzf-str-td>
          <qzf-str-td :disabled="expStatus" v-model:amount="list[0].bqynse"  @change="changeList()"></qzf-str-td>
          <td><input type="text" v-model="list[0].jmxzdm"></td>
          <qzf-str-td :disabled="false" v-model:amount="list[0].jmse" @change="changeList()"></qzf-str-td>
          <qzf-str-td :disabled="false" v-model:amount="list[0].jzbl" @change="changeList()"></qzf-str-td>
          <qzf-str-td :disabled="expStatus" v-model:amount="list[0].jze" @change="changeList()"></qzf-str-td>
          <qzf-str-td :disabled="false" v-model:amount="list[0].bqyjse" @change="changeList()"></qzf-str-td>
          <qzf-str-td :disabled="expStatus" v-model:amount="list[0].bqybtse" @change="changeList()"></qzf-str-td>
        </tr>
        <tr class="border_none_tr">
          <td class="center">{{list[1].zsxm_dm}}</td>
          <qzf-str-td :disabled="false" v-model:amount="list[1].zzsse" @change="changeList()"></qzf-str-td>
          <qzf-str-td :disabled="false" v-model:amount="list[1].sl" @change="changeList()"></qzf-str-td>
          <qzf-str-td :disabled="expStatus" v-model:amount="list[1].bqynse" @change="changeList()"></qzf-str-td>
          <td><input type="text" v-model="list[1].jmxzdm"></td>
          <qzf-str-td :disabled="false" v-model:amount="list[1].jmse" @change="changeList()"></qzf-str-td>
          <qzf-str-td :disabled="false" v-model:amount="list[1].jzbl" @change="changeList()"></qzf-str-td>
          <qzf-str-td :disabled="expStatus" v-model:amount="list[1].jze" @change="changeList()"></qzf-str-td>
          <qzf-str-td :disabled="false" v-model:amount="list[1].bqyjse" @change="changeList()"></qzf-str-td>
          <qzf-str-td :disabled="expStatus" v-model:amount="list[1].bqybtse" @change="changeList()"></qzf-str-td>
        </tr>
        <tr class="border_none_tr">
          <td class="center">{{list[2].zsxm_dm}}</td>
          <qzf-str-td :disabled="false" v-model:amount="list[2].zzsse" @change="changeList()"></qzf-str-td>
          <qzf-str-td :disabled="false" v-model:amount="list[2].sl" @change="changeList()"></qzf-str-td>
          <qzf-str-td :disabled="expStatus" v-model:amount="list[2].bqynse" @change="changeList()"></qzf-str-td>
          <td><input type="text" v-model="list[2].jmxzdm"></td>
          <qzf-str-td :disabled="false" v-model:amount="list[2].jmse" @change="changeList()"></qzf-str-td>
          <qzf-str-td :disabled="false" v-model:amount="list[2].jzbl" @change="changeList()"></qzf-str-td>
          <qzf-str-td :disabled="expStatus" v-model:amount="list[2].jze" @change="changeList()"></qzf-str-td>
          <qzf-str-td :disabled="false" v-model:amount="list[2].bqyjse" @change="changeList()"></qzf-str-td>
          <qzf-str-td :disabled="expStatus" v-model:amount="list[2].bqybtse" @change="changeList()"></qzf-str-td>
        </tr>

        <tr>
          <td class="center">合计</td>
          <td class="center">----</td>
          <td class="center">----</td>
          <td>{{sum1}}</td>
          <td class="center">----</td>
          <td>{{sum2}}</td>
          <td class="center">----</td>
          <td>{{sum3}}</td>
          <td>{{sum4}}</td>
          <td>{{sum5}}</td>
        </tr>
      </table>
    </div>

    <div class="save_box">
      <el-button @click="saveValues" type="primary" size="mini" plain>保存</el-button>
    </div>
  </div>
  
</template>

<script>
import { gsInfo , gsEdit} from '@/api/taxCalculation.js'
export default {
  name: 'fb2',
  props: {
    title: String,
    comId:{
      default:0,
      type:Number
    },
  },
  data() {
    return {
      expStatus: true,
      list:[{},{},{}],
      infoFjs:{
        zc:0,
        jsyj:'',
        qtxgyy:''
      },
      taxNo: '',
      comName: '',
      durationOfTaxTime:'',
      jsyjOption:[
        {
          value:'1|本期行政区划调整，出现适用2档城建税税率情况',
          label:'1|本期行政区划调整，出现适用2档城建税税率情况'
        },
        {
          value:'2|经营业务特殊，适用2档以上城建税税率',
          label:'2|经营业务特殊，适用2档以上城建税税率'
        },
        {
          value:'3|其他',
          label:'3|其他' 
        }
      ]
    }
  },
  computed: {
    //金额合计
    sum1(){
      let sum
      sum = Number(this.list[0].bqynse) + Number(this.list[1].bqynse) + Number(this.list[2].bqynse)
      return sum.toFixed(2)
    },
    sum2(){
      let sum
      sum = Number(this.list[0].jmse) + Number(this.list[1].jmse) + Number(this.list[2].jmse)
      return sum.toFixed(2)
    },
    sum3(){
      let sum
      sum = Number(this.list[0].jze) + Number(this.list[1].jze) + Number(this.list[2].jze)
      return sum.toFixed(2)
    },
    sum4(){
      let sum
      sum = Number(this.list[0].bqyjse) + Number(this.list[1].bqyjse) + Number(this.list[2].bqyjse)
      return sum.toFixed(2)
    },
    sum5(){
      let sum
      sum = Number(this.list[0].bqybtse) + Number(this.list[1].bqybtse) + Number(this.list[2].bqybtse)
      return sum.toFixed(2)
    },
    
  },
  created() {
    
  },
  methods: {
    // 公式
    changeList(){
      if(!this.expStatus){
        return
      }
      this.list.map(v=>{
        v.bqynse = String(((v.zzsse*1 + v.zzsmdse*1 - v.ldtsbqkce*1) * v.sl).toFixed(2))
        v.jze =  String(((v.bqynse*1 - v.jmse*1) * v.jzbl).toFixed(2))
        v.bqybtse = String((v.bqynse*1 - v.jmse*1 - v.jze*1 - v.bqyjse*1).toFixed(2))
      })
    },
    getList(){
      gsInfo({tableName: 'gs_small_vat',itemName:'fb2'}).then(res=>{
        if(res.data.data.info){
          this.list = res.data.data.info
          this.durationOfTaxTime = res.data.data.time
            // this.infoFjs = response.data.data.info;
        }
      })
    },
    saveValues(){
      let param = {
        tableName:'gs_small_vat',
        itemName:'fb2',
        items:this.list
      }
      gsEdit(param).then(res => {
        if(res.data.msg == "success") {
          this.$qzfMessage("保存成功")
          this.getList()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 180px !important;
}
.save_box{
  margin: 0 auto;
  margin-top: 20px;
  text-align: center;
}
.content{
  // width: 2000px;
  width: 100%;
  margin: 0 auto;
  border:1px solid #c2c2c2;
  border-bottom: none;
  border-right: none;
  margin-top: 10px;
 
  span{
    line-height: 28px;
    font-size: 14px;
  }
  tr{
    padding: 0;
    margin: 0;
  }
  td{
    border-right:1px solid #c2c2c2;
    border-bottom:1px solid #c2c2c2;
    line-height: 25px;
    padding:0 6px;
    color: #333;
    font-size: 14px;
  } 
}
.left_k{
  text-indent: 2em;
}
.left_b{
  text-indent: 4em;
}
.left_x{
  text-indent:5em;
}
.left_d{
  text-indent:8em;
}
.top_title3{
  width: 100%;
  margin: 0 auto;
  h4{
    font-size: 20px;
    color: #333;
    font-weight: 600;
    text-align: center;
  }
  h5{
    font-size: 16px;
    color: #333;
    font-weight: normal;
    text-align: center;
    margin-top: 10px;
  }
  .bottom_font{
    width: 100%;
    margin: 0 auto;
    margin-top: 10px;
    h6{
      float: left;
      width: 33.33%;
      font-size: 14px;
      color: #333;
      font-weight: normal;
    }
    h6:nth-child(1){
      padding-top: 10px;
    }
    h6:nth-child(2  ){
      padding-top: 10px;
    }
  }
}
.center{
  text-align: center;
}
.left{
  text-align: left;
}
.right{
  text-align: right;
}
.weight{
  font-weight: 700;
}
.row_box{
  border-bottom: 1px solid #eee;
}
.big_box4{
  width: 98%;
  // padding: 40px;
  background: #fff;
  // box-shadow: 0 2px 10px #ddd;
  margin: 0 auto;
  box-sizing: border-box;
}
.content{
  input{
    width: 100%;
    line-height:25px;
    padding: 0 6px;
    font-size: 14px;
  }
}
.qsly{
  margin: 4px 5px 0 0;
  float: right;
  color: #666;
  // border: 0;
  // background: #fff;
  cursor: pointer;
}
</style>
